import * as ActionTypes from '../ToggleMatch';

export function toggleMatch(data, section) {
    return {type: ActionTypes.TOGGLE_MATCH, data, section};
}



// WEBPACK FOOTER //
// ./js/actions/creators/ToggleMatch.js